import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-percentage-difference',
  templateUrl: './percentage-difference.component.html',
  styleUrls: ['./percentage-difference.component.css']
})
export class PercentageDifferenceComponent implements OnInit {

  @Input()
  percentageValue: number;

  @Input()
  showContainer: boolean;

  constructor() { }

  ngOnInit() {
  }

  isPositive(): boolean {
    return this.percentageValue > 0;
  }

  isNegative(): boolean {
    return this.percentageValue < 0;
  }

  getAbsoluteValue(value: number) {
    return Math.abs(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/master-summary/percentage-difference/percentage-difference.component.ts